export default "__VITE_ASSET__CaQ1ha05__"